import { render, staticRenderFns } from "./YoutubeVid.vue?vue&type=template&id=77833c06&scoped=true"
import script from "./YoutubeVid.vue?vue&type=script&lang=js"
export * from "./YoutubeVid.vue?vue&type=script&lang=js"
import style0 from "./YoutubeVid.vue?vue&type=style&index=0&id=77833c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77833c06",
  null
  
)

export default component.exports